import React, {useState} from "react";
import { StyleSheet, css } from "aphrodite";

export default function MainSupportSection(){
    //#region 
    const [isButtonHover, setIsButtonHover] = useState(false);

    const [content, setContent] = useState({
        name:'',
        email:'',
        phoneNumber:'+1',
        companyName:'',
        explanation:'',
    });
    const sendInfo = () =>{
        setContent()

    }
    //#endregion

    //#endregion
    const styles = StyleSheet.create({
        mainContainerStyle: {
            backgroundColor: '#011a39',
            width: '100%',
            display: 'flex',
            justifyContent: ' center',
            alignItems: 'center',
            flexDirection:'column',
            gap: '20px',
            padding:'15px 0',
            "@media (min-width: 1024px)": {
                height: '80rem',
            }
        },
        titleStyle: {
            fontFamily: 'Oswald',
            fontStyle: "bold",
            fontSize: "3rem",
            textAlign: "center",
            color: '#fec803'
        },
        supportAplicationFormStyle: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: ' center',
            alignItems: 'center',
            padding:'3%',
            border: 'darkgray',
            borderRadius:'10px',
            backgroundColor: '#F0EFEC'
        },
        aplicationTitleStyle: {
            color: '#fec803',
            fontFamily: "Oswald",
            fontSize:'2rem',
            padding:'20px',
            fontStyle: "bold",

        },
        supportTextStyle: {
            color: '#F0EFEC',
            textAlign: 'justify',
            fontFamily: "Montserrat",
            width: '80%',
            "@media (min-width: 1024px)": {
                width: '50%',
            }
        },
        inputContainerStyle: {
            display: 'flex',
            flexDirection: 'column',
            gap: '1.5rem'

        },
        subTitleStyle: {
            color: '#011a39',
            textAlign: 'justify',
            fontFamily: "Montserrat",
            fontStyle: "bold",
            fontSize:'1.2rem'

        },
        buttonStyle: {
            fontFamily: "Oswald",
            fontSize:'1.5rem',
            display: "inline-block",
            cursor: "pointer",
            userSelect: "none",
            color: isButtonHover ? "#fec803":"#F0EFEC",
            backgroundColor: isButtonHover ? "#F0EFEC" : "#fec803",
            border: "none",
            padding:"0.52rem 4rem",
            margin: "1rem 0px 0.8rem",
            borderRadius:'6px',
            transition:'0.3s'
        },
        input: {
            border:'1px solid #D5D5D5',
            borderRadius:"5px",
            backgroundColor: "transparent",
            width: "100%",
            height:'2rem',
            fontFamily:'Chakra Petch',
            fontSize:'1rem',
            outline: '2px solid transparent',
            outlineOffset: '2px',
            padding:'0px',
            paddingLeft:'0.2rem',
        },

        secondInput: {
            minHeight:'8rem',
            border:'1px solid #D5D5D5',
            borderRadius:"5px",
            backgroundColor: "transparent",
            width: "100%",
            height:'2rem',
            fontFamily:'Chakra Petch',
            fontSize:'1rem',
            outline: '2px solid transparent',
            paddingLeft:'0.2rem',
            /*tablet and bigger screens*/
            "@media (min-width: 1024px)": {
                // width:'50%',
            },
            boxSizing: "border-box",
            mozBoxSizing: "border-box",
            webkitBoxSizing: "border-box",
        }
    })
    return(
        <>
            <form className={css(styles.mainContainerStyle)} action={()=>sendInfo()}>
                <div className={css(styles.titleStyle)}>CUSTOMER SUPPORT</div>
                <div className={css(styles.supportTextStyle)}>We’re committed to providing exceptional support and service. Whether you need help with a product, have questions about maintenance, or need assistance with your order, our team is here to assist you every step of the way.</div>
                <div className={css(styles.supportAplicationFormStyle)}>
                    <div className={css(styles.aplicationTitleStyle)}>APPLICATION</div>
                    <div className={css(styles.inputContainerStyle)}>
                    <label for='name'  className={css(styles.subTitleStyle)} >Full Name </label>
                    <input  type="text"  name="name"
                        className={css(styles.input)}/>
                </div>
                <div className={css(styles.inputContainerStyle)}>
                    <label for="email" className={css(styles.subTitleStyle)} >Email </label>
                    <input  type="email" name="email" 
                        className={css(styles.input)}/>
                </div>
                <div className={css(styles.inputContainerStyle)}>
                    <label for="phone" className={css(styles.subTitleStyle)} >Phone Number </label>
                    <input  name="phone" type="number"
                    className={css(styles.input)}/>
                </div>
                <div className={css(styles.inputContainerStyle)}>
                    <label for="company" className={css(styles.subTitleStyle)} >Company Name </label>
                    <input  type="text" name="company" 
                    className={css(styles.input)}/>
                </div>
                <div className={css(styles.inputContainerStyle)}>
                    <label for="description" className={css(styles.subTitleStyle)} >Please explain the reason your trying to contact us as detaild as possible. </label>
                    <input type="text" name="description" 
                    className={css(styles.secondInput )}/>
                </div>
                <div className={css(styles.inputContainerStyle)}>
                    <span className={css(styles.subTitleStyle)}> </span>
                    <button type="submit"
                        onMouseEnter={() => setIsButtonHover(true)} 
                        onMouseLeave={() => setIsButtonHover(false)} 
                        className={css(styles.buttonStyle)}>SUBMIT</button>
                </div>
                </div>
            </form>
        </>
    )
}